import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Management = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M10,0 C4.47666667,0 0,4.47666667 0,10 C0,15.5233333 4.47666667,20 10,20 C15.5233333,20 20,15.5233333 20,10 C20,4.47666667 15.5233333,0 10,0 M10,17.7777778 C5.71222222,17.7777778 2.22222222,14.2888889 2.22222222,10 C2.22222222,5.71222222 5.71222222,2.22222222 10,2.22222222 C14.2877778,2.22222222 17.7777778,5.71222222 17.7777778,10 C17.7777778,14.2888889 14.2877778,17.7777778 10,17.7777778 M14.4444444,11.1111111 C14.4444444,11.7255556 13.9477778,12.2222222 13.3333333,12.2222222 L10,12.2222222 C9.38555556,12.2222222 8.88888889,11.7255556 8.88888889,11.1111111 L8.88888889,5.55555556 C8.88888889,4.94333333 9.38555556,4.44444444 10,4.44444444 C10.6144444,4.44444444 11.1111111,4.94333333 11.1111111,5.55555556 L11.1111111,10 L13.3333333,10 C13.9477778,10 14.4444444,10.4988889 14.4444444,11.1111111"
				id="management"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Management.propTypes = {
	color: PropTypes.string,
};

export default Management;
